import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=65b9cb14"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=65b9cb14&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports